import React from 'react';
import Hero from './Hero'
import ValueProps from './ValueProps';
import ProblemSection from './ProblemSection';
import SolutionsSection from './SolutionsSection';
import SiemSection from './SiemSection';
import IndustrySection from './IndustrySection';
import WorkflowSection from './WorkflowSection';

function Home() {
  return (
    <div>
      <Hero />
      <ValueProps />
      <main>
        <ProblemSection />
        <div id="solutions">
          <SolutionsSection />
        </div>
        <div id="usecases">
          <SiemSection />
        </div>
        <div id="industries">
          <IndustrySection />
        </div>
        <WorkflowSection />
      </main>
    </div>
  );
}

export default Home;
